import moment from "moment";
import { API_BASE_URL, FAILURE, GET, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaMascota(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "mascota/obtener-lista-mascotas",
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
            for (let i = 0; i < data.body.length; i++) {
                data.body[i].fechaProceso = moment(data.body[i].fechaProceso).format('DD/MM/YYYY HH:mm');
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaMascota err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function guardarImagenMascota(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "mascota/guardar-imagen-mascota",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("guardarImagenMascota err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function crearMascota(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "mascota/create-mascota",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("guardarImagenMascota err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarMascota(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "mascota/update-mascota",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarMascota err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarMascota(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "mascota/disable-mascota",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarMascota err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerListaMascotaPorRefugio(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "mascota/obtener-lista-mascotas-por-refugio",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
            for (let i = 0; i < data.body.length; i++) {
                data.body[i].fechaProceso = moment(data.body[i].fechaProceso).format('DD/MM/YYYY HH:mm');
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaMascotaPorRefugio err");
        console.log(err);
        return { error: true, message: err };
    }
}